/**
 * Replace non-finite numbers and string "NaN" with null so expression
 * null-checks behave consistently with JSON/Mongo payloads.
 */

function isNaNString(s: string): boolean {
  return s.trim().toLowerCase() === 'nan'
}

function sanitizeValueDeep(v: any): any {
  if (v instanceof Date) return v
  if (Array.isArray(v)) return v.map(sanitizeValueDeep)
  if (typeof v === 'number' && !Number.isFinite(v)) return null
  if (typeof v === 'string' && isNaNString(v)) return null
  if (v !== null && typeof v === 'object') return sanitizePlainObjectDeep(v)
  return v
}

function sanitizePlainObjectDeep(obj: Record<string, any>): Record<string, any> {
  const next: Record<string, any> = {}
  for (const k of Object.keys(obj)) {
    next[k] = sanitizeValueDeep(obj[k])
  }
  return next
}

export function sanitizeNonFiniteData(data: any): any {
  if (data == null) return data
  if (Array.isArray(data)) return sanitizeValueDeep(data)
  if (typeof data === 'object') return sanitizePlainObjectDeep(data)
  return sanitizeValueDeep(data)
}

export function sanitizeExpressionResult(value: any): any {
  return sanitizeNonFiniteData(value)
}
